import { Autosuggest } from '@myap/ui-library/esm/components'

export const AutosuggestProxy = props => {
  const { input, meta, ...remainingProps } = props
  const mergedProps = { ...input, ...meta, ...remainingProps }
  return <Autosuggest {...mergedProps} />
}
